import {getDownloadURL, getStorage, ref} from "firebase/storage";

export class FileService {
    public downloadPattern(): Promise<string | void> {
        const storage = getStorage();
        const gsReference = ref(storage, 'gs://knitting-10398.appspot.com/PCTHatPattern_April2023.pdf');
        return getDownloadURL(gsReference);
    }
}